import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpYiiService } from '@submodules/MOA/services/http-yii.service';
import { MOAItemInterface } from '@submodules/MOA/interfaces/moa.interface';

@Injectable({
    providedIn: 'root',
})
export class MoaRequestsService {
    private _serviceClientRestApiHttp: HttpYiiService;
    private _clientBaseHttp: HttpClient;
    private host: Observable<string>;

    constructor(clientBaseHttp: HttpClient, serviceClientRestApiHttp: HttpYiiService) {
        this._serviceClientRestApiHttp = serviceClientRestApiHttp;
        this._clientBaseHttp = clientBaseHttp;
        this.host = this._serviceClientRestApiHttp.url;
    }

    public getSettings(id: number, ext: string): Observable<any> {
        const url: string = this.host + '/moa/settings/editor/' + id + '/id/' + ext + '/ext';

        return this._clientBaseHttp.get(url, {
            withCredentials: true,
        });
    }

    public getPageInfo(id: number): Observable<any> {
        const url: string = this.host + '/moa/report-reglam/' + id;

        return this._clientBaseHttp.get(url, {
            withCredentials: true,
        });
    }

    public getConfigFromReportReglam(payload: MOAItemInterface): Observable<any> {
        const url: string = this.host + '/config_for_report_reglam';

        return this._clientBaseHttp.post(url, payload, {
            withCredentials: true,
        });
    }
}
